module.exports = __webpack_public_path__ + "img/PercentileRadar.75ba44f4.jpg";